import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import { OrgDoc } from "api/memberPortal/orgs/orgs.types";
import IconMenuItem from "components/MUI/DataGrid/Cells/Actions/IconMenuItem";

interface SerialNumberActionCellProps {
  document: OrgDoc;
  setShowEditModal: (_show: boolean) => void;
  setDocument: (_document: OrgDoc) => void;
  setShowDeleteModal: (_show: boolean) => void;
}

const SerialNumberActionCell = ({
  document,
  setShowEditModal,
  setDocument,
  setShowDeleteModal,
}: SerialNumberActionCellProps) => {
  const handleEdit = () => {
    setDocument(document);
    setShowEditModal(true);
  };

  const handleDelete = () => {
    setDocument(document);
    setShowDeleteModal(true);
  };

  return (
    <>
      <IconMenuItem Icon={EditIcon} label="Edit" onClick={handleEdit} />
      <IconMenuItem Icon={DeleteIcon} label="Delete" onClick={handleDelete} />
    </>
  );
};

export default SerialNumberActionCell;
